import CircleBank from 'src/components/common/icons/CircleBank';
import CircleDeposit from 'src/components/common/icons/CircleDeposit';
import CircleDocument from 'src/components/common/icons/CircleDocument';
import CircleOne from 'src/components/common/icons/CircleOne';
import CircleThree from 'src/components/common/icons/CircleThree';
import CircleTwo from 'src/components/common/icons/CircleTwo';

export const BASE_PATH = document.location.origin;
export const SERVICE_BASE_URL = `${BASE_PATH}/api`;

export const PageRoutes = {
  HOME: '/',
  DATACOLLECTION: '/data-collection',
  CONFIRMATION: '/docusign-return',
  ERROR: '/error',
};

export const FlowTrackerSteps = [
  'Initiate transfer',
  'Select external account to transfer from',
  'Select holdings to transfer',
  'Select TRP account to transfer into',
  'Review transfer details',
  'Submit asset transfer',
];

export const FlowTrackerConfirmationSteps = [
  'Transfer request submitted',
  'We’ll review and contact your firm',
  'Other firm reviews and approves the request',
  'Your assets arrive',
];

export const SplashPageContent1 = [
  {
    message:
      'Have the account number, online login information (if any), and name of the firm you are transferring assets from handy.  You’ll need that information to complete the transfer process.',
    Icon: CircleBank,
  },
  {
    message:
      'Decide whether you are transferring the entire account balance or just specific investments.',
    Icon: CircleDeposit,
  },
  {
    message:
      "If your transfer requires paperwork, you'll need a copy of your full account statement dated within the last 90 days.",
    Icon: CircleDocument,
  },
];
export const SplashPageContent2 = [
  {
    message:
      'If you want to open a new T. Rowe Price account to transfer your assets into, you’ll have the option to do so during this transfer process.',
    Icon: CircleOne,
  },
  {
    message:
      'Once you have completed your part of the process online, we’ll work with the other firm to transfer your assets in-kind to your selected T. Rowe Price account.',
    Icon: CircleTwo,
  },
  {
    message:
      'We’ll keep you updated by email on the status of your asset transfer. It may take 5-7 business days to see your assets transfer reflected in your T. Rowe Price account.',
    Icon: CircleThree,
  },
];

export const emptyAccountBalance = { currency: 'USD', amount: 0 };
export const validationErrorMessage = {
  MANUAL_PARTIAL_TRANSFER: 'Please complete missing information in order to proceed',
  PARTIAL_TRANSFER:
    'Please select a minimum of one holding to transfer in order to proceed',
  MISSING_HOLDING: 'Please complete missing information in order to proceed',
  EMPTY_HOLDING: 'Please select a minimum of one holding to transfer in order to proceed',
  ZERO_QUANTITY: 'Please enter a share amount greater than 0 in order to proceed',
  SELECT_HOLDING: 'Please choose holdings to move forward',
};

export const serviceTermsUrl =
  'https://www.troweprice.com/content/dam/iinvestor/products-and-services/adv/Aggregation-Services-Terms.pdf';

export const CHOOSE_ACCOUNT_TYPE_FAQ = [
  {
    title:
      'Which types of transfers are eligible for my T. Rowe Price Brokerage accounts?',
    panel: [
      'To transfer funds into your Brokerage account, the accounts involved must have the same registration. This means both the sending and receiving accounts should have the same owners and be of the same type.',
      'You can transfer from various account types, including but not limited to individual, joint, trust, estate, UGMA/UTMA, Traditional/Rollover IRA, Roth IRA, Inherited IRA, Inherited Roth IRA, Simple IRA, SEP IRA, Money Purchase Pension Plan (MPP), Profit Sharing Plan (PSP), and Individual 401(k).',
      'The holdings you can transfer include a wide range of assets such as equities, bonds, CDs, mutual funds from other providers, options, Unit Investment Trusts (UITs), Exchange Traded Funds (ETFs), rights and warrants, and American depositary receipts.',
    ],
  },
  {
    title: 'What if I’m not sure what to select?',
    panel: [
      'Different financial institutions may use varying labels for account types.',
      'For example, an account labeled as an "IRA" at one institution might correspond to what T. Rowe Price identifies as a "Traditional IRA" or a "Rollover IRA." (A Rollover IRA is a type of Traditional IRA that contains assets transferred from an employer retirement plan.) Similarly, accounts that T. Rowe Price refers to as "general investing" or "nonretirement individual and joint accounts" might be called "brokerage," "regular," "standard," or "taxable" accounts by other institutions.',
    ],
  },
  {
    title:
      'What if my account at T. Rowe Price is not compatible with the type of account I want to transfer?',
    panel:
      'We help you to open new account types that you may need as part of the online transfer process. If you require a different type of account, you will be prompted to go through the online new account opening process. Once that account is open, you can then return to the asset transfer flow to complete the request.',
  },
  {
    title:
      'Are there types of securities that I cannot transfer into my T. Rowe Price brokerage account?',
    panel: [
      'T. Rowe Price does reserve the right to reject transfers which include securities we deem ineligible. These may include, but are not limited to, annuities, certain low-priced securities, alternative investments (e.g., hedge funds, private equity, currency), non-publicly traded securities or foreign securities that do not trade in the U.S., futures, options, margin balances, short positions, restricted stock, fixed income products (e.g., certificates of deposit, bonds), commodities, precious metals, physically held securities, initial public offerings (IPOs), certain cannabis-aligned securities, and certain mutual funds.',
      'If you have questions about the eligibility of external assets, please contact us.',
    ],
  },
  {
    title: 'Can I transfer cryptocurrency to T. Rowe Price?',
    panel: [
      'No, cryptocurrency (and certain other investments) cannot be transferred "in-kind" (moved directly) from your current financial institution to T. Rowe Price.',
      "When an investment cannot be transferred, you have two options: 1. Sell the investment at your current financial institution before starting the transfer (keep in mind that selling might come with fees or tax consequences), or 2. Go ahead with a partial transfer of any investments that can be moved. The ones that can't be transferred will stay with your current financial institution.",
    ],
  },
  {
    title:
      'What if the account at my current financial institution has more than one account owner?',
    panel: [
      'Your current financial institution may require all owners on both accounts to sign the "Transfer Assets to T. Rowe Price Form."',
      'You will be prompted to download the form to be completed, signed, and mailed.',
    ],
  },
  {
    title: 'How to move a 401(k) or 403(b)?',
    panel: [
      "If you're looking to bring over your 401(k) or 403(b) to T. Rowe Price, visit our public site page to see how you can move your employer plan.",
      'When you are ready to begin the process, you can get started by going to either our brokerage transfer or mutual fund transfer pages.',
      'An Individual 401(k) transfer can be accommodated as long as there is an existing T. Rowe Price Individual 401(k) account.',
    ],
  },
];

export const SPLASH_PAGE_FAQ = [
  {
    title: 'What is an external brokerage transfer?',
    panel:
      'An external brokerage transfer involves moving assets directly from an account at one financial institution to an account at T. Rowe Price without selling them. This process can be used for both retirement and non-retirement accounts. The accounts must have the same registration in order to transfer in-kind. It can also be referred to as an ACAT (Automated Customer Account Transfer).',
  },
  {
    title: 'What other transfers does T. Rowe Price support?',
    panel: [
      'In addition to asset transfers, T. Rowe Price supports:',
      'Mutual fund transfers--Transfer IRA or taxable mutual fund assets held at another financial institution to your new or existing T. Rowe Price mutual fund. Visit our transfer page for more information.',
      'Internal transfers--Move assets between your T. Rowe Price accounts. Visit our exchange flow to learn more.',
      'ACH transfers--Fund an account via a bank you link to your profile. Visit our mutual fund buy or brokerage trading pages to learn more.',
    ],
  },
  {
    title: 'Are there any transfers that require the assistance of T. Rowe Price?',
    panel: [
      'Some specialized transfer requests require the assistance of a specialist. We can help you move the following:',
      '-APP',
      '-Direct Mutual Fund Transfer',
      '-DRS (Direct Registration System)',
      '-DWAC (Deposit/Withdrawal at Custodian)',
      "Some accounts aren't available at T. Rowe Price, such as life insurance policies and health savings and 529 accounts.",
    ],
  },
  {
    title: 'How long will it take for my transfer to complete?',
    panel: [
      'T. Rowe Price generally processes transfer requests the same day we receive them.',
      'If your current financial institution uses the ACAT (Automated Customer Account Transfer) system, you can expect the transfer to complete in approximately 5 to 7 business days.',
      'If your current financial institution does not use the ACAT system, it may take between 15 to 30 business days. In some cases, unforeseen circumstances with the delivering institution may extend the account transfer periods.',
      'Once the assets are at T. Rowe Price, you will have full access to your cash and securities.',
    ],
  },
  {
    title: 'How will my assets transfer to T. Rowe Price and will it be done online?',
    panel: [
      'Eligible assets transfer to T. Rowe Price in-kind. That means your funds and securities will move from the original account and financial institution directly into your T. Rowe Price account.',
      'The transaction typically takes place entirely online. On certain occasions there may be a need for something to be printed; in these cases, we will provide a prefilled transfer form for you to print, sign, and mail.',
    ],
  },
  {
    title: 'What’s the difference between a rollover and an investment account transfer?',
    panel: [
      'A rollover is when you move your retirement assets from an employer plan to another employer plan or to an individual retirement account (IRA).',
      'An investment account transfer moves your financial assets from one place to another. T. Rowe Price accepts transfers from most IRAs, individual and joint nonretirement accounts, trusts, and custodial accounts (such as UGMA/UTMAs).',
      'Note that an IRA can be liquidated and transferred as cash, which is a taxable event. A non-retirement account transferred in-kind would not be a taxable event.',
    ],
  },
  {
    title: 'What is required to be approved for margin or options trading?',
    panel:
      'For margin or options trading, you have two options to get started: call 1-800-341-1211 to review what is required; or download, complete, and return the "Margin/Option Account Form."',
  },
];

export const INITIATE_TRANSFER_FAQ = [
  {
    title: 'What if my firm’s not listed?',
    panel:
      'If the name of your financial firm is not displayed when you type it in the search box, check a recent statement for the exact name and spelling, and type that name in the box. Some firms have different divisions for banking, investing, insurance, or institutional retirement plans, and these may have different names. If you continue to have this issue after adjusting your search terms, you will have the option to enter your information manually.',
  },
  {
    title: 'What if I’m not sure which firm to select?',
    panel:
      "If you're not sure which firm holds your account, look at a recent statement. Some firms have differently named divisions for banking, investing, insurance, or institutional retirement plans. You may see names of different divisions or firms with similar names when you type in the search box. Choose the one that holds your account.",
  },
];

export const SELECT_EXTERNAL_ACCOUNT_FAQ = [
  {
    title: 'How do I transfer only part of my account?',
    panel:
      'You can choose to transfer part of your account by selecting "Partial Transfer." You will be able to transfer a specific number of shares of an investment or a certain dollar amount for a cash transfer.  Your investment details are available on your latest statement from your current financial institution.',
  },
  {
    title:
      'How do I know if all my current holdings can transfer to T. Rowe Price without needing to be sold?',
    panel: [
      'Investments that can be transferred "in-kind" (moved directly) to T. Rowe Price include most stocks, bonds, ETFs, mutual funds, options, CDs held in a brokerage account, and unit investment trusts. Some mutual funds might need to be sold and transferred as cash.',
      "If you're moving assets from a money market fund, the shares will be sold, and the money will be moved as cash into the settlement fund that comes with your brokerage account. If you own stocks trade for less than $1.00 per share, these might also need to be sold and transferred as cash.",
      "We'll let you know if you have assets that can't be transferred.",
    ],
  },
  {
    title: 'Why are some of my accounts listed as ineligible?',
    panel: [
      'Certain T. Rowe Price account types are unable to receive assets from other financial institutions. For example, non-brokerage accounts can only hold T. Rowe Price mutual funds and cannot receive other types of securities.',
      'In most cases, brokerage accounts can only receive assets from matching account types. (For example, Roth IRA assets must transfer into a Roth IRA account.)',
      'If you are notified that you have an ineligible account, you can choose to either transfer these assets to another eligible account (see the FAQ "Which types of transfers are eligible for my T. Rowe Price Brokerage accounts?") or open a new brokerage account for these assets.',
    ],
  },
  {
    title: 'What if I’m transferring more than one account?',
    panel:
      'You can complete more than one transfer, but can only complete one transfer request of one account at a time. If you are in the middle of a transfer and want to complete more, you need to complete the current transfer request process. At the end of that request process, you will have the option to request another account transfer.',
  },
  {
    title:
      'What happens to the fractional shares in the external accounts I’m transferring to T. Rowe Price?',
    panel: [
      "For full account transfers, fractional shares are automatically sold (liquidated) at your current financial institution and transferred over to your T. Rowe Price account with the rest of the account's cash balance or later via a residual sweep.",
      'For partial account transfers, by selecting “all shares” the fractional shares will be automatically sold (liquidated), but the cash proceeds will remain at your other institution.',
      'Fractional shares of security investments may need to be sold (liquidated) before transferring.',
    ],
  },
];

export const MANUAL_TRANSFER_FAQ = [
  {
    title: 'Where can I find my account number?',
    panel: [
      "Your account number can be found on a recent statement from your current financial institution. This number identifies the specific account you're moving from (such as a Roth IRA or a nonretirement brokerage account). It may be all numeric or a combination of letters and numbers.",
      "Some statements also list numbers that identify specific funds and investments. You may need these numbers if you're transferring part of your account.",
    ],
  },
  {
    title:
      'How do I know if all my current holdings can transfer to T. Rowe Price without needing to be sold?',
    panel: [
      'Investments that can be transferred "in-kind" (moved directly) to T. Rowe Price include most stocks, bonds, ETFs, mutual funds, options, CDs held in a brokerage account, and unit investment trusts. Some mutual funds might need to be sold and transferred as cash.',
      "If you're moving assets from a money market fund, the shares will be sold, and the money will be moved as cash into the settlement fund that comes with your brokerage account. If you own stocks trade for less than $1.00 per share, these might also need to be sold and transferred as cash.",
      "We'll let you know if you have assets that can't be transferred.",
    ],
  },
  {
    title: 'What should I select for Accounts?',
    panel:
      'Select the account (registration) type you plan to transfer in-kind which is the like-registered account you have at T. Rowe Price.',
  },
  {
    title: 'How do I transfer only part of my account?',
    panel:
      'You can choose to transfer part of your account by selecting "Partial Transfer." You will be able to transfer a specific number of shares of an investment or a certain dollar amount for a cash transfer.  Your investment details are available on your latest statement from your current financial institution.',
  },
  {
    title: 'What should I enter for “approximate” dollar amount?',
    panel: [
      "Enter an estimate of the dollar value of the assets you're transferring. You can estimate the dollar value by looking at a recent statement or by logging onto your account at the other financial institution.",
      "Your estimate will help us prepare for the transfer, but the actual amount transferred may differ from your estimate for a number of reasons such as market fluctuations or if your transfer request includes any investments that can't be held at T. Rowe Price.",
    ],
  },
  {
    title: 'What if I’m transferring more than one account?',
    panel:
      'You can complete one transfer request of one account at a time. If you are in the middle of a transfer and want to complete more, you need to complete the current transfer request process. At the end of that request process, you will have the option to request another account transfer.',
  },
];

export const PARTIAL_TRANSFER_FAQ = [
  {
    title: 'What’s a CUSIP?',
    panel:
      'A CUSIP (Committee on Uniform Securities Identification Procedures) number is a unique 9-character code that identifies each security approved for trading in the United States. It can be used to identify an investment you want to transfer if a ticker symbol is not available.',
  },
  {
    title:
      'What if I don’t know my number of shares or the dollar value of my cash assets?',
    panel: [
      'To complete a partial transfer you need to enter a specific share or dollar value. You can refer to your most recent account statement from your existing institution for updated values.',
      'To transfer cash, enter your highest estimate of the cash balance. To transfer shares, enter your desired amount.',
      'If you wish to transfer all assets from the account, you can go back to the previous page and choose to transfer all assets from your account.',
    ],
  },
  {
    title: 'What options do I have if my holding can’t be transferred?',
    panel:
      "When an investment can't be transferred, you have two options: 1. Sell the investment at your current financial institution before starting the transfer. Keep in mind that selling might come with fees or tax consequences. Or, 2. Go ahead with a partial transfer of any investments that can be moved. The ones that can't be transferred will stay with your current financial institution.",
  },
  {
    title:
      'What happens to the fractional shares in the external accounts I am transferring to T. Rowe Price?',
    panel: [
      "For full account transfers, fractional shares are automatically sold (liquidated) at your other institution and transferred over to your T. Rowe Price account with the rest of the account's cash balance or later via a residual sweep.",
      'For partial account transfers, by selecting “all shares” the fractional shares will be automatically sold (liquidated), but the cash proceeds will remain at your other institution.',
      'Fractional shares of security investments may need to be sold (liquidated) before transferring.',
    ],
  },
];

export const SELECT_INTERNAL_ACCOUNT_FAQ = [
  {
    title: 'Why are some of my accounts listed as ineligible?',
    panel: [
      'Certain T. Rowe Price account types are unable to receive assets from other financial institutions. For example, non-brokerage accounts can only hold T. Rowe Price mutual funds and cannot receive other types of securities.',
      'In most cases, brokerage accounts can only receive assets from matching account types. (For example, Roth IRA assets must transfer into a Roth IRA account.)',
      'If you are notified that you have an ineligible account, you can choose to either transfer these assets to another eligible account (see the FAQ "Which types of transfers are eligible for my T. Rowe Price Brokerage accounts?") or open a new brokerage account for these assets.',
    ],
  },
];

export const REVIEW_FAQ = [
  {
    title: 'What are the fees associated with asset transfers?',
    panel:
      'Here is a link to the T. Rowe Price Commission and Fee Schedule (https://www.troweprice.com/content/dam/iinvestor/products-and-services/Brokerage/brokerage-commission-schedule.pdf).',
  },
  {
    title: 'Will transferring this account be a taxable event?',
    panel:
      "In most cases, if you're moving a retirement account to a T. Rowe Price retirement account of the same type, you likely won't incur taxes--you are changing the investment but assets are not leaving the retirement account, so there is no tax liability or tax reporting. For taxable accounts, a transfer in kind from another institution usually does not create tax liability.",
  },
  {
    title: 'How is my cost basis handled?',
    panel: [
      'Securities acquired prior to the effective dates are considered “noncovered securities,” and your current financial institution is not required to transfer cost basis information to T. Rowe Price. For noncovered securities, you may choose or change the cost basis method up to the time of sale, but we do not report cost basis information for noncovered securities to the IRS.',
      'Securities acquired on or after the effective dates for cost basis reporting are considered “covered securities,” and your current financial institution is required to transfer the cost basis information to T. Rowe Price. In general, you will have the opportunity to choose or change the cost basis method on any covered securities transferred up to the time of sale.',
    ],
  },
  {
    title:
      'How will I know that my transfer is complete? And when will I be able to access my money?',
    panel: [
      'T. Rowe Price generally processes transfer requests the same day we receive them.',
      'If your existing institution leverages the ACAT (Automated Customer Account Transfer) system, you can expect the transfer to complete in approximately 5 to 7 business days.',
      'If your resigning institution does not use the ACAT system, it may take between 15 to 30 business days. In some cases, unforeseen circumstances with the delivering institution may extend the account transfer periods.',
      'Once the assets are at T. Rowe Price, you will have full access to your cash and securities.',
    ],
  },
  {
    title: 'When is additional documentation needed?',
    panel: [
      'We recommend that you have a recent statement from the account you’re transferring available as you complete your transfers.',
      "If you've experienced a major life event, like marriage, divorce, or the loss of a loved one, you may also be asked to provide additional documentation as part of the transfer process.",
    ],
  },
];

export const REQUIRES_PAPERWORK = [
  {
    title: 'When is additional documentation needed?',
    panel:
      "We recommend that you have a recent statement from the account you’re transferring available as you complete your transfers. If you've experienced a major life event, like marriage, divorce, or the loss of a loved one, you may also be asked to provide additional documentation as part of the transfer process.",
  },
];
